import { render } from "./LeaderboardSection.vue?vue&type=template&id=8752cf2c&scoped=true"
import script from "./LeaderboardSection.vue?vue&type=script&lang=js"
export * from "./LeaderboardSection.vue?vue&type=script&lang=js"

import "./LeaderboardSection.vue?vue&type=style&index=0&id=8752cf2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8752cf2c"]])

export default __exports__